import { isObjectLike, isNaN, isUndefined } from 'lodash';

import { resetVehicleFromShowroomVehicle } from 'commons-vehicle/Vehicle/services/VehicleService/VehicleService.js';

import TradeInVehicleModel from 'commons-vehicle/Vehicle/models/TradeInVehicleModel.js';
import VehicleModel from 'commons-vehicle/Vehicle/models/VehicleModel.js';

function parseAmount(amount) {
    let parsedAmount = 0;
    if (amount) {
        parsedAmount = parseInt(amount, 10);
    }
    return !isNaN(parsedAmount) ? parsedAmount : 0;
}

export function resetTradeInVehicleFromShowroomTradeInVehicle(tradeInVehicle) {
    if (!isObjectLike(tradeInVehicle)) {
        return new TradeInVehicleModel();
    }

    const { id, status, lien, amount, evaluationQuestion, taxesFactor, taxCodes } = tradeInVehicle;

    let vehicle = new VehicleModel();
    if (isObjectLike(tradeInVehicle.vehicle)) {
        vehicle = resetVehicleFromShowroomVehicle(tradeInVehicle.vehicle);
    }

    return new TradeInVehicleModel({
        id,
        status,
        taxesFactor: isUndefined(taxesFactor) ? 0 : taxesFactor,
        taxCodes: isUndefined(taxCodes) ? [] : taxCodes,
        vehicle,
        lien,
        amount,
        evaluationQuestion,
        modified: false,
    });
}

export function setTaxesFactor(tradeInVehicle, purchaseMethods) {
    const lien = { ...tradeInVehicle.lien, amount: purchaseMethods.lien };
    return tradeInVehicle
        .set('amount', purchaseMethods.tradeIn)
        .set('lien', lien)
        .set('taxesFactor', purchaseMethods.taxesFactor)
        .set('taxCodes', purchaseMethods.taxCodes);
}

// For Pricing API V2.5 uses to have tradeInTaxCredits in place of taxes factor
export function setTaxCreditDetails(tradeInVehicle, taxCreditDetails) {
    return tradeInVehicle
        .set('tradeInTaxCredits', taxCreditDetails.tradeInTaxCredits)
        .set('taxCodes', taxCreditDetails.taxesDetail);
}

export function setTradeIn(tradeInVehicle, tradeInAmount) {
    const parsedTradeInAmount = parseAmount(tradeInAmount);
    if (tradeInVehicle.amount === parsedTradeInAmount) {
        return tradeInVehicle;
    }

    return tradeInVehicle.set('amount', parsedTradeInAmount).set('modified', true);
}

export function setLien(tradeInVehicle, lienAmount) {
    const { lien } = tradeInVehicle;
    const parsedLienAmount = parseAmount(lienAmount);
    if (lien.amount === parsedLienAmount) {
        return tradeInVehicle;
    }

    lien.amount = parsedLienAmount;
    return tradeInVehicle
        .set('lien', lien)
        .set('lienAmount', parsedLienAmount)
        .set('modified', true);
}

export default {
    resetTradeInVehicleFromShowroomTradeInVehicle,
    setTradeIn,
    setLien,
};
